export default {
  url: 'URL',
  ptDbId: 'PT Database ID',
};
